import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
  {
    url_id: "/laporan/list-fitur-kuasa",
    url_path: "/laporan/list-fitur-kuasa",
  },
];
